import * as yup from 'yup';
import validator from 'validator';
import tlds from 'tlds';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

const TLD_SET = new Set(tlds);

function emailHostTldInIcannList(email: string): boolean {
  const at = email.lastIndexOf('@');
  if (at < 0) return false;
  const host = email.slice(at + 1).toLowerCase();
  const dot = host.lastIndexOf('.');
  if (dot < 0) return false;
  const tld = host.slice(dot + 1);
  return tld.length > 0 && TLD_SET.has(tld);
}

export const numberSchema = yup.string().test({
  name: 'phoneNumber',
  test(value, ctx) {
    const phoneNumber = parsePhoneNumberFromString(value || '');
    if (phoneNumber && phoneNumber.isValid()) {
      return true;
    }
    return ctx.createError({ message: `Invalid phone number: ${value || ''}` });
  },
})

const NAME_PATTERN = /^[\p{L}\p{M}\s'-]+$/u;

export const emailSchema = yup
  .string()
  .transform((value) => (typeof value === 'string' ? value.trim() : value))
  .required('Email is required')
  .max(255, 'Email must be at most 255 characters')
  .test({
    name: 'emailFormat',
    message: 'Please enter a valid email address',
    test(value) {
      if (value == null || value === '') return false;
      if (!validator.isEmail(value, { allow_utf8_local_part: true, require_tld: true })) return false;
      return emailHostTldInIcannList(value);
    },
  });

export const nameSchema = yup
  .string()
  .transform((value) => (typeof value === 'string' ? value.trim() : value))
  .test({
    name: 'preferredName',
    test(value, ctx) {
      if (!value) {
        return ctx.createError({ message: 'Preferred Name is required' });
      }
      if (value.length < 3) {
        return ctx.createError({ message: 'Preferred Name should be at least 3 characters long' });
      }
      if (value.length > 20) {
        return ctx.createError({ message: 'Preferred Name should be no more than 20 characters' });
      }
      if (!NAME_PATTERN.test(value)) {
        return ctx.createError({ message: 'Preferred Name can only contain letters, spaces, hyphens and apostrophes' });
      }
      return true;
    },
  });